import { render, staticRenderFns } from "./NavigationManagementMenu.vue?vue&type=template&id=520caf99&"
import script from "./NavigationManagementMenu.vue?vue&type=script&lang=js&"
export * from "./NavigationManagementMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports